module.exports = __webpack_public_path__ + "static/img/矩形@2x(23).63f6138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shisanwu/矩形@2x(23).png
// module id = bGi/
// module chunks = 1